import NamedDto from 'modules/base/dto/NamedDto';

export class worksheetModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.worksheet = null;
		/** @type {string} */
		this.cell = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _worksheetModelInputAttributeEditDtoProps	
	 * @property {string} type
	 * @property {string} value
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {string} uom
	 * @property {string} worksheet
	 * @property {string} cell
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _worksheetModelInputAttributeEditDtoProps} worksheetModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {worksheetModelInputAttributeEditDtoProps} props
	 * @returns {worksheetModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.value = props.value;
		this.minValue = props.minValue !== undefined ? props.minValue : props.min_value;
		this.maxValue = props.maxValue !== undefined ? props.maxValue : props.max_value;
		this.uom = props.uom;
		this.worksheet = props.worksheet;
		this.cell = props.cell;
		this.orderIndex = props.orderIndex;

		return this;
	}
}

export default worksheetModelInputAttributeEditDto;
